/**
 * Modelos de datos para el componente Create Supplier
 */

/**
 * Modos de operación del componente
 * - invitation: Usuario accediendo desde link de email
 * - embedded: Componente embebido en otro componente
 */
export type CreateSupplierMode = 'invitation' | 'embedded';

/**
 * Interface para el formulario de creación de supplier
 */
export interface CreateSupplierForm {
  // Datos de invitación
  sendInvitation: boolean;
  contactName: string;
  contactEmail: string;
  
  // Identificación del Proveedor
  rutEmpresa: string;
  razonSocial: string;
  nombreComercial: string;
  tamano: string;
  actividadEconomica: string;
  tipoRelacion: string; // cardId seleccionado
  
  // Datos del Proveedor
  direccion: string;
  cobertura: string;
  clasificacionProveedor: string;
  fono: string;
  mail: string;
  productosServicios: string[];
  cuentas: {
    banco: string;
    tipo: string;
    numero: string;
  }[];
  
  // Configuración de campos
  cardFieldsConfig: {
    [sectionId: string]: {
      [fieldId: string]: 'required' | 'optional' | 'not_used';
    };
  };
}

/**
 * Payload para el WS register-business-partner
 */
export interface RegisterBusinessPartnerRequest {
  companyId: string;
  usuarioId: string;
  empresa: {
    rutEmpresa: string;
    razonSocial: string;
    tamano: string;
    actividadEconomica: string;
    nombreComercial: string;
    direccion: string;
    cobertura: string[];
    fono: string;
    mail: string;
    productosServicios: string[];
    cuentas: {
      cuentaId?: string;
      tipoCuenta: string;
      banco: string;
      numeroCuenta: string;
    }[];
  };
  socioNegocio: {
    clienteId?: string;
    clienteRut?: string;
    tipoRelacion: string;
    clasificacionProveedor: string;
    ficha: any[];
  };
}

/**
 * Payload para el WS send-email
 */
export interface SendEmailRequest {
  userId: string;
  emailContacto: string;
  nombreContacto: string;
  companyId: string | number;
  tipoRelacion: string;
  clase: string;
  rut: string,
  razonSocial: string,
  nombreComercial: string,
  tamano: string,
  actividadEconomica: string,
}

/**
 * Valores por defecto para el formulario
 */
export const DEFAULT_CREATE_SUPPLIER_FORM: CreateSupplierForm = {
  sendInvitation: true,
  contactName: '',
  contactEmail: '',
  rutEmpresa: '',
  razonSocial: '',
  nombreComercial: '',
  tamano: '',
  actividadEconomica: '',
  tipoRelacion: '',
  direccion: '',
  cobertura: '',
  clasificacionProveedor: '',
  fono: '',
  mail: '',
  productosServicios: [],
  cuentas: [{
    banco: '',
    tipo: '',
    numero: ''
  }],
  cardFieldsConfig: {}
};

/**
 * Interface para la respuesta del WS get-info-empresa-scm
 */
export interface EmpresaScmInfo {
  rut: string;
  nombre: string;
  razonSocial: string;
  tamano: string;
  actividadEconomica: string;
}